import { Flex } from "@chakra-ui/react";
import ContentRightItem from "./ContentRightItem";
import StatusContentRight from "./StatusContentRight";
import { ClienteContrato } from "core/features/cliente/typings";

interface ContentRightProps {
  item?: ClienteContrato;
}

export default function ContentRight({ item }: ContentRightProps) {
  return (
    <Flex flexDir="column" w="100%" pr={4}>
      <StatusContentRight item={item} />
      <ContentRightItem
        titulo="Multa após 15 dias"
        valor={item?.multa ? `${item?.multa}%` : "--"}
      />
      <ContentRightItem
        titulo="Desconto pagto antes do vencimento"
        valor={item?.desconto ? `${item?.desconto}` : "--"}
      />
    </Flex>
  );
}
